import React from "react";

export const Page404 = () => {
  return <p>ページが見つかりません</p>;
};
